import { __awaiter } from "tslib";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginType, useSendSecureCodeMutation } from '@websky/graphql';
import { useLoginFormError } from '../../../hooks';
import FirstLoginAgreementBase from '../FirstLoginAgreement/FirstLoginAgreement';
import { useRenderers } from '../../../../renderProps';
import { useConfig } from '../../../../context';
import { isEmailDomainBlockedForRegistration } from '../../../utils';
const RegistrationForm = ({ login, loginType, onSuccess, onError }) => {
    var _a;
    const [sendCode, { loading }] = useSendSecureCodeMutation();
    const { t } = useTranslation('LoginPage');
    const blockedRegistrationEmailDomains = (_a = useConfig().global.authMethods) === null || _a === void 0 ? void 0 : _a.blockedRegistrationEmailDomains;
    const { setError, setDefaultError } = useLoginFormError(onError);
    const { FirstLoginAgreement: FirstLoginAgreementOverride = FirstLoginAgreementBase } = useRenderers();
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (loginType === LoginType.FFP) {
            onSuccess();
        }
        else {
            if (loginType === LoginType.Email &&
                isEmailDomainBlockedForRegistration(login, blockedRegistrationEmailDomains)) {
                onError(t('Registration with this email domain is forbidden'));
                return;
            }
            try {
                const data = yield sendCode({
                    variables: {
                        params: {
                            login,
                            loginType
                        }
                    }
                });
                if (data.data.SendSecureCode.result) {
                    onSuccess();
                }
                else {
                    setDefaultError();
                }
            }
            catch (e) {
                setError(e);
            }
        }
    }), [onSuccess, onError, login, loginType, t]);
    return React.createElement(FirstLoginAgreementOverride, { onConfirm: onSubmit, loading: loading });
};
export default RegistrationForm;
